import React from "react";

export const MyPageInquiryExpandIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M7.14253 7.14253L3.33301 3.33301M3.33301 6.38063V3.33301H6.38063M9.42825 9.42825L13.2378 13.2378M13.2378 10.1902V13.2378H10.1902"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
